import { createFileRoute } from "@tanstack/react-router";
import {TestList} from "@/raids/TestList.tsx";

export const Route = createFileRoute("/dev_/list")({
  component: () => <TestList />,
});
